import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { REPLACE_INGREDIENT_MUTATION } from '../graphql/mutations'
import { REPLACE_INGREDIENT } from '../redux/action-types'

const useReplaceIngredientMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.ingredients.ingredients,
  )

  const mutate = useCallback(
    async ({ idToReplace, replacementIds }) => {
      await apolloService.mutate(
        REPLACE_INGREDIENT_MUTATION,
        {
          idToReplace,
          replacementIds,
        },
        dispatch,
        REPLACE_INGREDIENT,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useReplaceIngredientMutation
